import {WebSocketMessageAdditionalData} from './WebSocketMessageAdditionalData';
import {
    InputSourceType
} from 'botato-botengine-browser/botato/botato-botengine/source/InstantMessagingAdapter/WebSocket/dto/InputSourceType.js';

export class WebSocketMessage {
    public userId!: string;

    constructor(public language: string,
                public clientId: string,
                public botId: string,
                public additionalData?: WebSocketMessageAdditionalData,
                public inputSource?: InputSourceType,
                public authToken?: string) {
    }
}
